// Constants
import { SET_TEST_VARIANT } from '@store/constants'

const initialState = {
  data: undefined,
  abTests: {}
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_TEST_VARIANT: {
      const { name, id, variant } = action
      const abTests = { ...state.abTests }
      abTests[name] = { id, variant }
      return {
        ...state,
        abTests
      }
    }

    default:
      return state
  }
}

export const selectTestVariant = ({ app }, type) => app.abTests?.[type]?.variant
export const selectTestId = ({ app }, type) => app.abTests?.[type]?.id
